var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgRegion = function SvgRegion(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0 24 0 24 24 0 24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4427489,86.9 L95.4427489,96 L4.54489872,96 L4.54489872,86.9 L9.08979124,86.9 L9.08979124,56.1511 C3.40722919,52.3539225 -0.0037605563,45.9647884 3.11136637e-06,39.125 C3.11136637e-06,35.36215 1.01806527,31.7358 2.87692631,28.64635 L15.2026748,7.275 C16.014521,5.86726085 17.5148593,5 19.1385517,5 L80.8536471,5 C82.4773395,5 83.9776776,5.86726085 84.789524,7.275 L97.0698236,28.5781 C102.702125,37.9436705 99.9838414,50.0874915 90.8978564,56.1511 L90.8978564,86.9 L95.4427489,86.9 Z M21.8904664,14 L10.8321535,32.9524672 C8.60334556,38.4028996 10.9927238,44.6326545 16.3144077,47.2461854 C21.6360917,49.8597162 28.0936155,47.9747613 31.1307255,42.921294 C32.6533456,39.1559925 38.0393303,39.1559925 39.5664956,42.921294 C41.2896721,47.1958986 45.4703707,50 50.1202986,50 C54.7702264,50 58.950925,47.1958986 60.6741015,42.921294 C62.1967217,39.1559925 67.5827064,39.1559925 69.1098717,42.921294 C70.7179267,46.8390438 74.4104597,49.5328727 78.6673411,49.8937947 C82.9242225,50.2547166 87.0258612,48.2217205 89.2837096,44.6317436 C91.5415581,41.0417662 91.5739449,36.501664 89.3675374,32.8804901 L78.3455855,14 L21.8950116,14 L21.8904664,14 Z",
    fill: "currentColor",
    fillRule: "nonzero"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgRegion);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "region.d627e660b0ecb0ee8ac4e50d5bb7e920.svg";